import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { toggleModal } from '../../redux/actions/placesModalActions';
import { fetchPlaceById } from '../../redux/actions/placeActions';
import { setSelectedPlaceId } from '../../redux/actions/selectedPlaceActions';

import Page from '../../components/Page';
import PlacesDesktop from './PlacesDesktop';
import PlacesModalSlider from './PlacesModalSlider';

import './Place.css';
import config from '../../config';
import { constructTitle } from '../Lodge/helpers';
import { appendHoneyGuide } from '../../lib/utils';

class Places extends Component {
  static getMetaTagsForSEO(placeData) {
    const { RESOURCE_URL } = config;
    const { name, region, banner_images, description } = placeData;
    const imageURI = (banner_images && `${RESOURCE_URL}/${banner_images.medium}`) || '';

    if (!isEmpty(placeData)) {
      const title = appendHoneyGuide(constructTitle({ name, region }));
      const image = imageURI;

      return {
        title,
        image,
        description: description || '',
      };
    }
  }

  render() {
    const { placeData, modalIsOpen } = this.props;

    return (
      <Page {...Places.getMetaTagsForSEO(placeData)}>
        <PlacesDesktop place={placeData} />
        {placeData.id && (
          <Modal isOpen={modalIsOpen} toggle={this.toggleModal} className="place-modal">
            <PlacesModalSlider placeId={placeData.id} />
          </Modal>
        )}
      </Page>
    );
  }

  componentDidMount() {
    const { placeId, placeData } = this.props.match.params;

    if (isEmpty(placeData)) this.props.fetchPlaceById(placeId);

    this.props.setSelectedPlaceId({ id: placeId });
  }

  toggleModal = () => {
    const { modalIsOpen, toggleModal } = this.props;
    const newModalState = !modalIsOpen;

    toggleModal(newModalState);
  };
}

const mapStateToProps = ({ schema, placesModal }, ownProps) => {
  const { placeId } = ownProps.match.params;

  return {
    placeData: schema.places.byId[placeId] || {},
    modalIsOpen: placesModal.modalIsOpen,
  };
};

export default connect(
  mapStateToProps,
  {
    fetchPlaceById,
    toggleModal,
    setSelectedPlaceId,
  }
)(Places);



// WEBPACK FOOTER //
// ./src/screens/Places/Places.jsx